module.exports = __webpack_public_path__ + "img/delay.3a6dcea3.png";